import { render, staticRenderFns } from "./EmployeePermissionWindow.vue?vue&type=template&id=54320de1&scoped=true"
import script from "./EmployeePermissionWindow.vue?vue&type=script&lang=js"
export * from "./EmployeePermissionWindow.vue?vue&type=script&lang=js"
import style0 from "./EmployeePermissionWindow.vue?vue&type=style&index=0&id=54320de1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54320de1",
  null
  
)

export default component.exports